import React from 'react';
import { Link } from 'react-router-dom';
import Icon from "@scentregroup/ui/components/icon";
import Heading from "@scentregroup/ui/components/heading";
import Paragraph from "@scentregroup/ui/components/paragraph";
import Row from "@scentregroup/ui/components/form/row";
import CallToAction from "@scentregroup/ui/components/call-to-action";
import OrderSummary from '@scentregroup/shared/components/order-summary';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const MkpEmptyCart = () => {
  const submitButtons = /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Row, {
      "data-id": "cart-preview-empty_index_submitButtons_Row",
      children: /*#__PURE__*/_jsx(CallToAction, {
        "data-test-id": "cart-continue-shopping-btn",
        element: Link,
        to: "/",
        "data-id": "cart-preview-empty_index_submitButtons_Row_CallToAction",
        children: "Continue Shopping"
      })
    })
  });

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsxs("div", {
        "data-id": "cart-preview-empty_index_submitButtons_div",
        children: [/*#__PURE__*/_jsxs("div", {
          className: style.centreAlign,
          "data-id": "cart-preview-empty_index_submitButtons_div_div_3",
          children: [/*#__PURE__*/_jsx(Icon, {
            size: "large",
            type: "shopping-cart",
            className: style.cartIcon,
            "data-id": "cart-preview-empty_index_submitButtons_div_Icon"
          }), /*#__PURE__*/_jsx(Heading, {
            type: "small",
            "data-id": "cart-preview-empty_index_submitButtons_div_Heading",
            children: "Your cart is currently empty"
          })]
        }), /*#__PURE__*/_jsx(Paragraph, {
          className: style.messageBorderTop,
          "data-id": "cart-preview-empty_index_submitButtons_div_Paragraph",
          children: "Continue shopping to explore our range of products and brands now available online"
        })]
      })
    }), /*#__PURE__*/_jsx(OrderSummary, {
      itemCount: 0,
      subTotal: 0,
      fees: [],
      total: 0,
      submitButtons: submitButtons,
      "data-id": "cart-preview-empty_index_submitButtons_OrderSummary"
    })]
  });
};

export default MkpEmptyCart;